import React, { useCallback, useEffect, useRef } from 'react';
import { Dropdown } from "react-bootstrap";
import useChatStore from './useChatStore';
import axios from "../../API/axios";

const DropDownBox = ({ visible, setVisibility, record }) => {
    const dropdownRef = useRef();
    const sessionId = localStorage.getItem("sessionId");

    // const { getChatList } = useChatStore();

    const toggleDropdown = () => {
        setVisibility(!visible);
    };

    const ReadChat = useCallback(async () => {
        const responseData = {
            deviceType: "Web",
            sessionId: sessionId,
            chatID: record.chatID,
        };
        try {
            await axios.post(`Message/ReadChat`, responseData).then((res) => {
                // getChatList()
            });
        } catch (e) {
            console.log(e);
        }
    }, [record]);

    const UnReadChat = useCallback(async () => {
        const responseData = {
            deviceType: "Web",
            sessionId: sessionId,
            chatID: record.chatID,
        };
        try {
            await axios.post(`Message/UnReadChat`, responseData).then((res) => {
                // getChatList()
            });
        } catch (e) {
            console.log(e);
        }
    }, [record]);

    const DeleteChat = useCallback(async (deleteEveryOne) => {
        const responseData = {
            deviceType: "Web",
            sessionId: sessionId,
            chatID: record.chatID,
            forEveryOne: deleteEveryOne
        };
        console.log('responseData', responseData);

        try {
            await axios
                .delete(`Message/DeleteChat`, { data: responseData }).then((res) => {
                    localStorage.setItem("DeletedChatId", record.chatID);
                    // getChatList();
                });
        } catch (e) {
            console.log(e);
        }
    }, [record]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setVisibility(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [dropdownRef]);

    return (
        <>
            {visible && (
                <Dropdown.Menu
                    show={visible}
                    ref={dropdownRef}
                    className={record.isOwned ? "position-left" : "position-right"}
                >
                    {record?.isOwned === false ? (record?.isRead === false ? (
                        <Dropdown.Item as="button" className="dropdownList">
                            <span
                                className="dropdown-btn"
                                onClick={() => {
                                    ReadChat();
                                }}
                            >
                                <div className="d-flex align-items-center">
                                    <span className="dropdownTxt f-12">Mark as Read</span>
                                </div>
                            </span>
                        </Dropdown.Item>
                    ) : (
                        <Dropdown.Item as="button" className="dropdownList">
                            <span
                                className="dropdown-btn"
                                onClick={() => {
                                    UnReadChat();
                                }}
                            >
                                <div className="d-flex align-items-center">
                                    <span className="dropdownTxt f-12">Mark as UnRead</span>
                                </div>
                            </span>
                        </Dropdown.Item>
                    )) : ''}

                    {record?.isDeleted === false ? (
                        <Dropdown.Item as="button" className="dropdownList">
                            <span
                                className="dropdown-btn"
                                onClick={() => {
                                    DeleteChat(false);
                                    toggleDropdown();
                                }}
                            >
                                <div className="d-flex align-items-center">
                                    <span className="dropdownTxt f-12">Delete For Me</span>
                                </div>
                            </span>
                        </Dropdown.Item>
                    ) : ''}

                    {record?.isOwned === true && record?.isCompleteDeleted === false ? (
                        <Dropdown.Item as="button" className="dropdownList">
                            <span
                                className="dropdown-btn"
                                onClick={() => {
                                    DeleteChat(true);
                                    toggleDropdown();
                                }}
                            >
                                <div className="d-flex align-items-center">
                                    <span className="dropdownTxt f-12">Delete For Everyone</span>
                                </div>
                            </span>
                        </Dropdown.Item>
                    ) : ''}
                </Dropdown.Menu>
            )}
        </>
    );
}

export default DropDownBox;
